import * as React from "react";

import primaryColour from "../constants";

function SvgVehicles(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  const { fill = primaryColour } = props;
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M1.61285 13.7347H13.7967C14.4056 13.7347 14.8988 13.2412 14.8988 12.6326V5.10205C14.8988 4.49319 14.4056 4 13.7967 4H1.61285C1.00426 4 0.510796 4.49319 0.510796 5.10205V12.6326C0.510796 13.2415 1.00426 13.7347 1.61285 13.7347Z"
        fill={fill}
      />
      <path
        d="M21.1227 7.20508H15.8576V11.5519V14.3071H15.2452H14.6328H0V17.246H1.76442C1.76442 17.2457 1.76442 17.2449 1.76442 17.2446C1.76442 15.9028 2.85214 14.8157 4.19336 14.8157C5.53484 14.8157 6.6223 15.9028 6.6223 17.2446C6.6223 17.2449 6.6223 17.2457 6.6223 17.246H14.6326H15.2449H15.8573H17.6939C17.6939 15.9104 18.7767 14.8275 20.1123 14.8275C21.4478 14.8275 22.5307 15.9104 22.5307 17.246H24V11.5519L21.1227 7.20508ZM15.8576 16.6336H15.2452V14.9197H15.8576V16.6336ZM22.8982 12.7921L16.9594 12.154V8.30713H20.5304L22.8979 11.8838V12.7921H22.8982Z"
        fill={fill}
      />
      <path
        d="M20.1296 19.1122C21.1611 19.1122 21.9973 18.2761 21.9973 17.2446C21.9973 16.2131 21.1611 15.377 20.1296 15.377C19.0982 15.377 18.262 16.2131 18.262 17.2446C18.262 18.2761 19.0982 19.1122 20.1296 19.1122Z"
        fill={fill}
      />
      <path
        d="M4.19334 19.1127C5.22467 19.1127 6.06072 18.2766 6.06072 17.2453C6.06072 16.214 5.22467 15.3779 4.19334 15.3779C3.16202 15.3779 2.32597 16.214 2.32597 17.2453C2.32597 18.2766 3.16202 19.1127 4.19334 19.1127Z"
        fill={fill}
      />
    </svg>
  );
}

export default SvgVehicles;
